/* ============================================================
   Article Featured Slider (vanilla, no deps)

   Runs against every [data-article-slider] on the page.
   Behaviour:
     - Click a thumbnail → activate that slide + highlight thumb.
     - Click prev / next arrows → cycle with wrap-around.
     - ← / → keys → cycle when focus is inside the slider.
     - Touch swipe on the main area → cycle.
     - Thumb strip auto-scrolls to keep the active thumb visible.
   Idempotent: safe to run multiple times (guarded by data-slider-initialized).
   ============================================================ */
(function () {
  'use strict';

  var SWIPE_THRESHOLD = 40; // px

  function initSlider(slider) {
    if (slider.dataset.sliderInitialized === 'true') return;
    slider.dataset.sliderInitialized = 'true';

    var main = slider.querySelector('[data-slider-main]');
    var thumbsWrap = slider.querySelector('[data-slider-thumbs]');
    if (!main) return;

    var slides = Array.prototype.slice.call(
      main.querySelectorAll('.article-clean__slider-slide')
    );
    var thumbs = thumbsWrap
      ? Array.prototype.slice.call(
          thumbsWrap.querySelectorAll('.article-clean__slider-thumb')
        )
      : [];

    if (slides.length < 2) {
      // Single slide — hide arrows + thumb strip, nothing to do.
      var singleArrows = slider.querySelectorAll('.article-clean__slider-arrow');
      for (var s = 0; s < singleArrows.length; s++) {
        singleArrows[s].style.display = 'none';
      }
      if (thumbsWrap) thumbsWrap.style.display = 'none';
      return;
    }

    var current = 0;

    function setActive(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      if (index === current) return;

      slides[current].classList.remove('is-active');
      slides[index].classList.add('is-active');

      if (thumbs[current]) thumbs[current].classList.remove('is-active');
      if (thumbs[index]) {
        thumbs[index].classList.add('is-active');
        scrollThumbIntoView(thumbs[index]);
      }

      current = index;
    }

    function scrollThumbIntoView(thumb) {
      if (!thumbsWrap) return;
      var wrapRect = thumbsWrap.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      if (thumbRect.left < wrapRect.left) {
        thumbsWrap.scrollBy({
          left: thumbRect.left - wrapRect.left - 8,
          behavior: 'smooth'
        });
      } else if (thumbRect.right > wrapRect.right) {
        thumbsWrap.scrollBy({
          left: thumbRect.right - wrapRect.right + 8,
          behavior: 'smooth'
        });
      }
    }

    /* ── Arrow buttons ── */
    var prevBtn = slider.querySelector('[data-slider-prev]');
    var nextBtn = slider.querySelector('[data-slider-next]');
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        setActive(current - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        setActive(current + 1);
      });
    }

    /* ── Thumbnails ── */
    for (var t = 0; t < thumbs.length; t++) {
      (function (btn, idx) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          setActive(idx);
        });
      })(thumbs[t], t);
    }

    /* ── Keyboard (arrow keys when focus is inside the slider) ── */
    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        setActive(current - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        setActive(current + 1);
      }
    });

    /* ── Touch swipe on the main area ── */
    var touchStartX = 0;
    var touchStartY = 0;
    var touching = false;

    main.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || !e.touches[0]) return;
        touching = true;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      },
      { passive: true }
    );

    main.addEventListener(
      'touchend',
      function (e) {
        if (!touching) return;
        touching = false;
        var endTouch =
          (e.changedTouches && e.changedTouches[0]) || null;
        if (!endTouch) return;
        var dx = endTouch.clientX - touchStartX;
        var dy = endTouch.clientY - touchStartY;
        if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) setActive(current + 1);
          else setActive(current - 1);
        }
      },
      { passive: true }
    );
  }

  function initAll(root) {
    var scope = root || document;
    var sliders = scope.querySelectorAll('[data-article-slider]');
    for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Re-initialise after Shopify section editor reloads this section */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
